import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import { ROUTE_HOME,ADMIN,ROUTE_ADMIN } from 'routes/routes';
import useAuthUser from './useAuthUser';
import { useFirebase } from 'components/Firebase/context';

const loader = false;
const withAuthorization = (condition = authUser =>  !!authUser, redirectRoute = ROUTE_HOME) => Component => {
  const WithAuthorization = props => {
    const authUser = useAuthUser();
    const firebase = useFirebase();
    console.log(authUser);
    useEffect(() => {
      const listener = props.firebase.auth.onAuthStateChanged(authUser => {

        if (authUser) {
            const getUser = async (uid) => {
             const User = await props.firebase.getUserDataById(uid).then( user => { return user} );
              if(User.status == 'success'){
                if(!User.user.roles) {
                  User.user.roles = {}
                }
                authUser = {
                  uid: authUser.uid,
                  email: authUser.email,
                  ...User.user,
                };
              }
            }
            getUser(authUser.uid);
        }
       if (!condition(authUser))
          props.history.push("ROUTE_HOME");
      });
      return () => listener();
    });

    return condition(authUser) ? <Component {...props} /> : null;
  };

  return compose(
    withRouter,
    withFirebase
  )(WithAuthorization);
};

export default withAuthorization;
